import axios from "axios"

const { data } = await axios.get('./globalConfig.json')
window.urlConfig = data

export default data